export default __webpack_public_path__ + "bdbd16e79b90bc5eb2c1e7b8b0fe97c3.svg";